import React from 'react'
import { Typography } from '@material-ui/core'

import { TopicIcon } from 'app/components/icons'
import clsx from 'clsx'

export default (props) => {
  const { id, name, style = {} } = props
  const { icon = 'min-w-14 h-14', text = 'text-12' } = style
  return (
    <Typography
      component="span"
      id={`topics-${id}`}
      className={clsx(text, 'font-normal text-blue-primary')}
      {...props}
    >
      <TopicIcon classes={clsx(icon, 'mr-1')} />
      {name}
    </Typography>
  )
}
